import type { TenantConfig } from '@/types/TenantConfig'

export const brma: TenantConfig = {
  logo: 'assets/brma/static/logo-2.png',
  teaserImageSize: {
    width: 272,
    height: 216,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;1,400;1,600&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      namedMembers: {
        singleOptionalLabel:
          'I would like to name a second adult member of my household as the second person for this membership.',
      },
      unnamedMembers: {
        label: 'Please specify the number of children 12 years old or younger in your household.',
      },
    },
  },
}
